export enum CursusStageCadre {
  DEFAULT = "default",
  ECE = "ece",
  MINES = "mines",
}
